// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyCRQcSZoBnO_spolcxdX0WpShsXpNHjwEo",
    authDomain: "userslist-9e729.firebaseapp.com",
    databaseURL: "https://userslist-9e729.firebaseio.com",
    projectId: "userslist-9e729",
    storageBucket: "userslist-9e729.appspot.com",
    messagingSenderId: "325834377217",
    appId: "1:325834377217:web:89b810f1e6207d14c2d800"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
